import ServiceEdit from "../components/ServiceEdit";
import {connect} from "react-redux";
import {isOnline} from "../actions/userActions";
import {loadServices, removeLogoOfService, updateService, uploadLogoForService} from "../actions/serviceActions";
import {isProcessing} from "../actions/processingActions";
import {PROC_SERVICE_LIST, PROC_SERVICE_UPDATE, PROC_SERVICE_UPDLOAD} from "../actions";
import {push} from 'react-router-redux';
import isFunc from 'lodash/isFunction';
import {showSnackbar} from "../actions/snachbarActions";
import {fetchKfzList} from "../actions/kfzActions";
import {fetchServiceKfzStates} from "../actions/service2kfzActions";

const m2s = (state, props) => {
	const service_id = Number(props.match.params.service_id);
	return {
		service: state.service.list[service_id] || {},
		isLoading: isProcessing(state, PROC_SERVICE_LIST),
		isUpdating: isProcessing(state, PROC_SERVICE_UPDATE, service_id),
		isUploading: isProcessing(state, PROC_SERVICE_UPDLOAD, service_id),
		kfz_list: state.kfz.list,
		service_list: state.service2kfz.service_2_kfz[service_id]
	};
};

const m2d = (dispatch, props) => {
	const service_id = Number(props.match.params.service_id);
	dispatch(isOnline(() => {
		dispatch(loadServices());
		dispatch(fetchKfzList());
		dispatch(fetchServiceKfzStates(service_id))
	}));
	return {
		push: to => dispatch(push(to)),
		onUpdate: (service, onSuccess) => dispatch(updateService(service, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.service.updated'));
		})),
		onUploadLogo: (service, image, onSuccess) => dispatch(uploadLogoForService(service, image, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.service.logo-uploaded'));
		})),
		onDeleteLogo: (service, onSuccess) => dispatch(removeLogoOfService(service, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.service.logo-removed'));
		}))
	};
};

export default connect(m2s, m2d)(ServiceEdit);


// WEBPACK FOOTER //
// ./src/containers/ServiceEditController.js